export default __webpack_public_path__ + "static/media/hht1_ep14_book_wp_02.d9e7a9a2.jpg";